import React, { useState } from 'react';
import './PricingSection.css';

const PricingSection: React.FC = () => {
  const [isYearly, setIsYearly] = useState(true);

  const plans = [
    {
      name: 'Edge',
      monthlyPrice: 15625,
      yearlyPrice: 12500,
      features: [
        'Upto 5 Users',
        'Unlimited minutes per user',
        'Live Dashboard for Call Analytics',
        '30-min App/Website setup for Customer Support or Field Ops.',
        'Secure Frontend integration (Register users via Taar\'AI Console)',
        '4.2+ Call Quality Score Guarantee across India'
      ],
      tagline: 'Feels alive, ready to grow.',
      savings: null
    },
    {
      name: 'Core',
      monthlyPrice: 137500,
      yearlyPrice: 110000,
      features: [
        'Everything in Edge, plus:',
        'Upto 50 Users',
        '50 Dedicated Landline Numbers',
        '50 Dedicated SIP Trunk',
        '10GB Recording Storage Space',
        'Real-time Agent Registration via API',
        'Regulatory Compliance Management'
      ],
      tagline: 'Feels alive, ready to grow.',
      savings: '12% Cheaper than Edge per user'
    },
    {
      name: 'Enterprise',
      monthlyPrice: 670000,
      yearlyPrice: 575000,
      features: [
        'Everything in Core, plus:',
        'Upto 350 Users',
        '350 Dedicated Landline Numbers',
        '350 Dedicated SIP Trunk',
        'Option to purchase additional users',
        'Regulatory Compliance Management'
      ],
      tagline: 'Feels alive, ready to grow.',
      savings: '32% Cheaper than Core per user'
    }
  ];

  const formatPrice = (price: number) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(price);
  };

  return (
    <section id="pricing" className="pricing-section">
      <div className="pricing-container">
        <div className="pricing-header">
          <h2 className="pricing-title">Simple, transparent pricing</h2>
          <p className="pricing-subtitle">No contracts. No surprise fees.</p>
        </div>

        <div className="pricing-toggle">
          <div className="toggle-container">
            <button
              className={`toggle-option ${!isYearly ? 'active' : ''}`}
              onClick={() => setIsYearly(false)}
            >
              Pay Monthly
            </button>
            <button
              className={`toggle-option ${isYearly ? 'active' : ''}`}
              onClick={() => setIsYearly(true)}
            >
              Pay Yearly
              <div className="yearly-savings">
                <span className="savings-text">Save Upto 25%</span>
                <span className="savings-arrow">→</span>
              </div>
            </button>
          </div>
        </div>

        <div className="pricing-cards">
          {plans.map((plan) => (
            <div 
              key={plan.name} 
              className={`pricing-card ${plan.name.toLowerCase()}`}
            >
              <div className="card-header">
                <h3 className="plan-name">{plan.name}</h3>
                <div className="plan-price">
                  {formatPrice(isYearly ? plan.yearlyPrice : plan.monthlyPrice)}
                  <span className="price-period">/ month</span>
                </div>
                <p className="plan-tagline">{plan.tagline}</p>
              </div>
              
              <div className="card-features">
                {plan.features.map((feature, index) => (
                  <div key={index} className="feature-item">
                    <span className="feature-check">✓</span>
                    <span className="feature-text">{feature}</span>
                  </div>
                ))}
              </div>
              
              {plan.savings && (
                <div className="plan-savings">
                  {plan.savings}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
